// extracted by css-extract-rspack-plugin
export default {"additionalSettingsSection":"PropertyDefinitionForm-module__additionalSettingsSection__RKskzM7","propertyFormControl":"PropertyDefinitionForm-module__propertyFormControl__I_1aFTY"};